import { ScreenSize } from '../../../enums';
import styled from 'styled-components';
import palette from '@mlc/mlc-palette';

export const List = styled.ul`
	padding: 0;

	@media (max-width: ${ScreenSize.medium}) {
		flex: none;
		margin-bottom: 0;
		margin-top: 0;
	}
`;

export const ListElement = styled.li`
	display: inline-block;
	margin: 0;
	padding-bottom: 10px;
	padding-right: 20px;

	a {
		color: ${palette.mlcWhite};

		:hover {
			color: ${palette.mlcWhite};
		}

		:focus {
			color: ${palette.mlcWhite};
		}
	}
`;

export const LastLogin = styled.p`
	color: ${palette.mlcWhite};
	flex: 1;

	/* margin: 16px 0; */
	padding-right: 15px;
	text-align: right;

	@media (max-width: ${ScreenSize.medium}) {
		flex: none;
		margin: 0;
		padding-right: 5px;
	}

	@media (max-width: ${ScreenSize.small}) {
		margin-bottom: 0;
		margin-top: 15px;
	}
`;
